import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { EnvironmentModel, Query, PagedResult } from '@common/generic';
import { User } from '../models/User';
import {FinalResponse} from '@app-so/participants/models/CertificateValidationModel';
import {log} from 'util';
import {ResetPasswordModel} from "@common/account/models/ResetPasswordModel";
import { AuthService } from '@generic/index';

@Injectable({
  providedIn: 'root'
})
export class UsersApiService {
  baseUrl: string;
  constructor(
    private auth: AuthService,
    private http: HttpClient, 
    private environment: EnvironmentModel
  ) {
    this.baseUrl = `${this.environment.apiEndpoint}/api/listUsers`;
  }

  getAll(query: Query) {
    const params = new HttpParams()
      .set('loginFilter', query.loginFilter)
      .set('filter', query.filter)
      .set('page', query.page.toString())
      .set('pageSize', query.pageSize.toString())
      .set('sortBy', query.sortBy)
      .set('sortOrder', query.sortOrder);
    return this.http.get<PagedResult<User>>(this.baseUrl, { params });
  }

  create(user: Partial<User>): Observable<FinalResponse> {
    return this.http.post<FinalResponse>(`${this.environment.apiEndpoint}/auth/api/createUser`, user);
  }

  get(id: string) {
    const token = this.auth.getToken();
    const headers = {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
      };
            
    return this.http.post<User>(`${this.environment.apiEndpoint}/api/getUserById`,{id},{headers});
  }

  sendActivate(user: Partial<User>): Observable<FinalResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const link = this.environment.apiEndpoint + '/api/activationEmail';
    return this.http.post<FinalResponse>(link, user, { headers });
  }
  sendResetPasswordEmailFromKeyCloak(user: Partial<User>): Observable<FinalResponse> {
    return this.http.post<FinalResponse>(`${this.environment.apiEndpoint}/api/forgotpassword`,user);
  }

  resetPassword(user: Partial<User>): Observable<FinalResponse> {
    return this.http.post<FinalResponse>(`${this.environment.apiEndpoint}/api/forgotpassword`, user);
  }


  update(user: Partial<User>): Observable<FinalResponse>  {
    return this.http.post<FinalResponse>(`${this.environment.apiEndpoint}/api/updateUser`, user);
  }

  activate(id: string): Observable<FinalResponse> {
    return this.http.get<FinalResponse>(`${this.environment.apiEndpoint}/api/user/activate/${id}`);
  }

  deactivate(id: string): Observable<FinalResponse> {
    return this.http.get<FinalResponse>(`${this.environment.apiEndpoint}/api/user/deactivate/${id}`);
  }
  delete(user: Partial<User>): any {
    return this.http.post<FinalResponse>(`${this.environment.apiEndpoint}/api/user/delete`, user);
  }
}
